<div id="recaptcha-container"></div>
<div class="container">
  <mat-card>
    <!-- Progress bar from Akita state -->
    <div class="auth-form-progress">
      @if (showProgress || (loading$ | async)) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>

    <img ngSrc="assets/images/Transparent-Logo-480w.png" class="logo" alt="Logo" width="480" height="357" priority />
    <p class="mat-headline-5">Prijavite se</p>

    <mat-card-content>
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
        @if (!phoneSubmitted) {
          <mat-grid-list cols="2" rowHeight="1:1" gutterSize="8px">
            <mat-grid-tile>
              <app-country-code-selector (codeSelected)="countryCodeSelected($event)" [displayCallingCode]="true">
              </app-country-code-selector>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-form-field appearance="fill">
                <mat-label>Broj telefona</mat-label>
                <input
                  matInput
                  formControlName="phoneNumber"
                  autocomplete="off"
                  inputmode="numeric"
                  placeholder="Broj telefona"
                />
                @if (phoneNumber.hasError('required')) {
                  <mat-error> Broj telefona je obavezan </mat-error>
                }
                @if (phoneNumber.hasError('minlength')) {
                  <mat-error> Broj telefona mora imati najmanje 6 cifara </mat-error>
                }
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        }

        <!-- Verification code section -->
        @if (phoneSubmitted) {
          <div>
            <p class="verification-info">
              SMS poruka sa 6-cifrenim verifikacionim kodom je upravo poslata na broj
              <strong>{{ loginForm.get('phoneNumber')?.value }}</strong>
            </p>
            <button type="button" mat-button class="resend-link" (click)="resendCode()">
              <strong>Izmeni telefon</strong>
            </button>
            <mat-form-field appearance="fill" class="verification-code-field">
              <mat-label>Verifikacioni kod</mat-label>
              <input
                matInput
                name="verificationCode"
                placeholder="XXXXXX"
                formControlName="verificationCode"
                autocomplete="off"
                inputmode="numeric"
              />
              @if (verificationCode.hasError('required')) {
                <mat-error> Ovo polje je obavezno </mat-error>
              }
            </mat-form-field>
            <div class="resend-block">
              <div>Kod nije stigao?</div>
              <button type="button" mat-button class="resend-link" (click)="resendCode()">
                <strong>Pošalji ponovo</strong>
              </button>
            </div>
          </div>
        }

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="disableSubmitButton()"
          class="submit-button"
        >
          {{ phoneSubmitted ? 'Potvrdi kod' : 'Pošalji kod' }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
